import React from 'react';
import { PrimitiveDotStroke as Dot } from 'styled-icons/octicons/PrimitiveDotStroke';
import * as Ui from './styles';

function MoreIcon(props) {
  const dotProps = {
    ...props,
    size: props.size / 1.666667,
  };
  return (
    <Ui.IconContainer style={{ display: 'flex', flexDirections: 'row' }}>
      <Dot {...dotProps} className={'icon'} />
      <Dot {...dotProps} className={'icon'} />
      <Dot {...dotProps} className={'icon'} />
    </Ui.IconContainer>
  );
}

export default MoreIcon;
